import { render, staticRenderFns } from "./bjyCustomStudent.vue?vue&type=template&id=3741eeb0"
import script from "./bjyCustomStudent.vue?vue&type=script&lang=js"
export * from "./bjyCustomStudent.vue?vue&type=script&lang=js"
import style0 from "./bjyCustomStudent.vue?vue&type=style&index=0&id=3741eeb0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports